import { authClient } from "@/lib/auth-client"

// Floating banner shown app-wide whenever an admin is impersonating another
// user. The active session IS the impersonated user's, with session.impersonatedBy
// set to the admin's id — so we read it straight off useSession and offer a
// one-click way to drop back to the real admin account.
export function ImpersonationBanner() {
  const { data } = authClient.useSession()
  const impersonatedBy = data?.session?.impersonatedBy
  if (!impersonatedBy) return null

  const handleStop = async () => {
    await authClient.admin.stopImpersonating()
    window.location.href = `/admin`
  }

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-3 rounded-full bg-amber-500 text-black text-xs font-medium px-4 py-2 shadow-lg">
      <span>
        Viewing as <span className="font-mono">{data?.user?.email}</span>
      </span>
      <button
        onClick={handleStop}
        className="rounded-full bg-black/80 text-white px-2.5 py-1 hover:bg-black transition-colors"
      >
        Stop
      </button>
    </div>
  )
}
